import React from 'react';
import UserProfilePicture from '../../../components/UserProfilePicture';
import Item from '../_types/Item';
import {
  ProfilePictureAndVerticalLineContainer,
  RootContainer,
  VerticalLine,
  ViewContainer,
} from './FeedItem.styles';
import Header from './contents/Header';
import Details from './contents/Details';
import Media from './contents/Media';
import Actions from './contents/Actions';
import { useNavigate } from 'react-router';
import Comment from '../Comment';
import EditDeleteEllipseFeedItem from './contents/EditDeleteEllipseFeedItem';
// import Me from '../../../_types/Me';
import MyPerson from '../_types/MyPerson';
import { usePermissions } from '../../../context/PermissionsContext/PermissionsContext';
import { PermissionKeys } from '../../../context/PermissionsContext/permissionTypes';
import { useTheme } from '../../../context/PermissionsContext/ThemeContext/ThemeContext';

interface Props {
  onDeleteFeedItem: (deletedFeedItem: Item) => void;
  feedItem: Item;
  // me: Me;
  myPersons: MyPerson[];
  isEditing: boolean;
  onChangeIsEditing: (newIsEditing: boolean) => void;
}

const FeedItemView = ({
  feedItem,
  onDeleteFeedItem,
  // me,
  myPersons,
  isEditing,
  onChangeIsEditing,
}: Props) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const { theme } = useTheme();
  const canEditPost = hasPermission(PermissionKeys.Other_EditComments, [
    feedItem.userID,
  ]);
  const canDeletePost = hasPermission(PermissionKeys.Other_RemoveComments, [
    feedItem.userID,
  ]);
  const showMenu = canEditPost || canDeletePost;

  if (
    feedItem.activityFeed.emoticons.items.some(
      (emoticon) => emoticon.user === null
    )
  ) {
    console.error(
      'Feed item is missing user',
      feedItem.activityFeed.emoticons.items
    );
  }

  const isPaivBot = feedItem?.name?.toLowerCase()?.includes('paivbot');

  return (
    <RootContainer>
      <ViewContainer
        style={{
          backgroundColor: theme.isDark ? theme.background3 : theme.background1,
        }}
      >
        <ProfilePictureAndVerticalLineContainer>
          <div
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              if (!isPaivBot) {
                navigate(
                  `/people/about/${feedItem.activityFeed.createdByUser?.id}`
                );
              }
            }}
          >
            <UserProfilePicture
              imageName={feedItem.activityFeed.createdByUser?.imageName || ''}
              initials={feedItem.name}
            />
          </div>
          {feedItem.activityFeed.comments.items.length === 1 ? (
            <VerticalLine />
          ) : null}
        </ProfilePictureAndVerticalLineContainer>
        <div style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                if (!isPaivBot) {
                  navigate(
                    `/people/about/${feedItem.activityFeed.createdByUser?.id}`
                  );
                }
              }}
            >
              <Header
                shortName={feedItem.name}
                fullName={feedItem?.name}
                createdAt={feedItem.createdAt}
              />
            </div>
            {showMenu && (
              <EditDeleteEllipseFeedItem
                isEditing={isEditing}
                onChangeIsEditing={onChangeIsEditing}
                onDeleteFeedItem={onDeleteFeedItem}
                // me={me}
                feedItem={feedItem}
              />
            )}
          </div>
          <div
            onClick={() => {
              navigate('/feed/comments', {
                state: {
                  activityFeedID: feedItem.activityFeed.id,
                  comments: feedItem.activityFeed.comments.items,
                  title: `Comments on ${feedItem.name}'s post`,
                  selectedComment:
                    feedItem.activityFeed.comments.items.length === 1
                      ? feedItem.activityFeed.comments.items[0]
                      : null,
                },
              });
            }}
          >
            <Details
              myPersons={myPersons}
              details={feedItem.activityFeed.header}
            />
            <Media
              imageName={feedItem.activityFeed.imageName}
              imageType={feedItem.activityFeed.imageType}
            />
          </div>
          <Actions
            totalComment={feedItem.activityFeed.comments.items.length}
            onNavigateToComments={() => {
              navigate('/feed/comments', {
                state: {
                  activityFeedID: feedItem.activityFeed.id,
                  comments: feedItem.activityFeed.comments.items,
                  title: `Comments on ${feedItem.name}'s post`,
                  selectedComment:
                    feedItem.activityFeed.comments.items.length === 1
                      ? feedItem.activityFeed.comments.items[0]
                      : null,
                },
              });
            }}
            emoticonList={feedItem.activityFeed.emoticons.items.filter(
              (emoticon) => emoticon.user !== null
            )}
            activityFeedID={feedItem.activityFeed.id}
          />
        </div>
      </ViewContainer>
      {feedItem.activityFeed.comments.items.length === 1 ? (
        // @ts-ignore
        <Comment
          myPersons={myPersons}
          commentId={feedItem.activityFeed.comments.items[0].id}
        />
      ) : null}
    </RootContainer>
  );
};

export default FeedItemView;
